export enum ProductSlugs {
	BANK_GUARANTEE = 'garantiya',
	PARTNER_VERIFICATION_SERVICE = 'servis-proverki-kontragenta',
	OPTSIYA_VED = 'optsiya-ved-rubli',
	NAVIGATOR_MSP = 'navigator-msp',
	DOCDOC = 'docdoc',
	PAKET_USLUG_LEGKIY_START = 'paket-uslug-legkiy-start',
	ZARPLATNYY_PROEKT = 'zarplatnyy-proekt',
	PREMIUM_DS = 'delovaya-sreda-premium',
	OPTSIYA_VED_RUBLI = 'optsiya-ved-rubli',
	PAKET_USLUG_VED_BEZ_GRANITS = 'paket-uslug-ved-bez-granits',
	SBEREGI_BIZNES = 'sberegi-biznes',
	INSALES = 'inseyls',
	TORGOVYY_EKVAYRING = 'torgovyy-ekvayring',
	SMART_TERMINAL = 'smart-terminal',
	MOBILNYY_KASSIR = 'mobilnyy-kassir',
	PAKET_USLUG_TOLKO_DLYA_IP = 'paket-uslug-tolko-dlya-ip',
}
